import React from 'react';
import Config from '../../config/Config';
import { connect } from 'react-redux';
import { sendFeedback } from '../../redux/testPage/testPage.actions';

const HelpModal = ({
	currentAttemptId,
	aSectionId,
	questionId,
	qdomain,
	qlevel,
	sendFeedback,
	supportEmail,
	supportPhone,
}) => {
	const collectFeedbackData = () => {
		var checkedValue = '';
		var inputElements = document.getElementsByClassName('helpCheckbox');
		for (var i = 0; inputElements[i]; ++i) {
			if (inputElements[i].checked) {
				if (checkedValue === '') {
					checkedValue = inputElements[i].value;
				} else {
					checkedValue = checkedValue + '|' + inputElements[i].value;
				}
			}
			inputElements[i].checked = false;
		}

		if (!!checkedValue) {
			sendFeedback(checkedValue);
		} else {
			document.getElementsByClassName('errorSubmit')[0].style.display = 'block';
		}
	};
	return (
		<div>
			<div
				className="modal fade help-popup in"
				tabIndex="-1"
				role="dialog"
				aria-labelledby="myModalLabel"
				id="help-popup"
			>
				<div className="modal-dialog" role="document">
					<div className="modal-content">
						<div className="modal-header">
							<h4 className="modal-title" id="myModalLabel">
								Help -{' '}
								{'STEP-ID' +
									qdomain +
									qlevel +
									'-' +
									currentAttemptId +
									'-' +
									questionId +
									'-S' +
									aSectionId}
							</h4>
						</div>
						<div
							className="alert alert-danger errorSubmit"
							style={{ display: 'none' }}
						>
							Please select a feedback
						</div>
						<div className="modal-body">
							<div className="row">
								<div className="col-lg-12 col-xs-12">
									<div className="help-info">
										<i className="fa fa-envelope-o"></i>{' '}
										<a href={`mailto:${supportEmail || 'info@steptest.in'}`}>
											{supportEmail || 'info@steptest.in'}
										</a>
									</div>
									{!supportPhone.includes(',') && (
										<div className="help-info">
											<img
												src={Config.ASSETSPATH + 'img/whatsapp-icon.png'}
												alt="whatsapp-icon"
											/>{' '}
											<a
												href={`https://web.whatsapp.com/send?phone=+91${supportPhone || 9789883344
													}&text=Hello%2C%20I%27m%20Interested%20in%20buying%20this%20course`}
												rel="noopener noreferrer"
												target="_blank"
											>
												+91-{supportPhone || 9789883344}
											</a>
										</div>
									)}

									{!!supportPhone && supportPhone.includes(',') ? (
										<div
											className="row help-info"
											style={{ display: 'flex', justifyContent: 'flex-end' }}
										>
											{supportPhone.split(',').map((phone) => (
												<div>
													<img
														src={Config.ASSETSPATH + 'img/whatsapp-icon.png'}
														alt="whatsapp-icon"
														style={{ paddingRight: '5px' }}
													/>
													<a
														href={`https://web.whatsapp.com/send?phone=${phone}&text=Hello%2C%20I%27m%20Interested%20in%20buying%20this%20course`}
														rel="noopener noreferrer"
														target="_blank"
													>
														{phone.trim()}
													</a>
												</div>
											))}
										</div>
									) : null}

									<div className="form-group">
										<label
											style={{ display: 'unset', marginBottom: '5px' }}
											className="modal-title"
										>
											Question Feedback
										</label>
										<div className="checkbox">
											<input
												id="box1"
												className="helpCheckbox"
												name="feedback[]"
												type="checkbox"
												value="I like this question"
											/>
											<label style={{ display: 'unset' }} htmlFor="box1">
												I like this question
											</label>
										</div>
										<div className="checkbox">
											<input
												id="box2"
												className="helpCheckbox"
												name="feedback[]"
												type="checkbox"
												value="Media did not play or cannot be heard"
											/>
											<label style={{ display: 'unset' }} htmlFor="box2">
												Media did not play or cannot be heard
											</label>
										</div>
										<div className="checkbox">
											<input
												id="box3"
												className="helpCheckbox"
												name="feedback[]"
												type="checkbox"
												value="Could not record speech"
											/>
											<label style={{ display: 'unset' }} htmlFor="box3">
												Could not record speech
											</label>
										</div>
										<div className="checkbox">
											<input
												id="box4"
												className="helpCheckbox"
												name="feedback[]"
												type="checkbox"
												value="Question is unclear or badly worded"
											/>
											<label style={{ display: 'unset' }} htmlFor="box4">
												Question is unclear or badly worded
											</label>
										</div>
										<div className="checkbox">
											<input
												id="box5"
												className="helpCheckbox"
												name="feedback[]"
												type="checkbox"
												value="Question has a grammar error or other mistake"
											/>
											<label style={{ display: 'unset' }} htmlFor="box5">
												Question has a grammar error or other mistake
											</label>
										</div>
										<div className="checkbox">
											<input
												id="box6"
												className="helpCheckbox"
												name="feedback[]"
												type="checkbox"
												value="Question is inappropriate or offensive"
											/>
											<label style={{ display: 'unset' }} htmlFor="box6">
												Question is inappropriate or offensive
											</label>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div className="modal-footer">
							<span
								style={{ cursor: 'pointer' }}
								className="btn btn-primary btn-popup close"
								data-dismiss="modal"
								id="submitInstruction"
								onClick={collectFeedbackData}
							>
								Submit
							</span>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

const mapStateToProps = (state) => {
	const {
		currentAttemptId,
		leftSectionProps,
		aSectionId,
		rightFeedbackProps,
		questionId,
		isFeedback,
	} = state.rootReducer.testPageDetails;
	const {
		supportEmail = 'info@steptest.in',
		supportPhone = '9789883344',
	} = state.rootReducer.loginDetails;
	return {
		currentAttemptId,
		leftSectionProps,
		aSectionId,
		questionId,
		qdomain: isFeedback ? rightFeedbackProps.qdomain : leftSectionProps.qdomain,
		qlevel: isFeedback ? rightFeedbackProps.qlevel : leftSectionProps.qlevel,
		supportEmail,
		supportPhone,
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		sendFeedback: (checkedValue) => dispatch(sendFeedback(checkedValue)),
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(HelpModal);
